import { z } from 'zod';
import { PermissionsMapSchema, ScopeSchema } from './common';

const RoleSlugSchema = z
  .string()
  .min(2)
  .max(40)
  .regex(/^[a-z0-9][a-z0-9-]*$/, 'Lowercase letters, digits and dashes only');

export const RoleSchema = z.object({
  id: z.string().uuid(),
  slug: RoleSlugSchema,
  name: z.string().min(1).max(40),
  isSystem: z.boolean(),
  isEditable: z.boolean(),
  scope: ScopeSchema,
  permissions: PermissionsMapSchema,
});
export type Role = z.infer<typeof RoleSchema>;

export const CreateRoleSchema = z.object({
  slug: RoleSlugSchema,
  name: z.string().min(1).max(40),
  scope: ScopeSchema,
  permissions: PermissionsMapSchema,
});
export type CreateRoleRequest = z.infer<typeof CreateRoleSchema>;

export const UpdateRoleSchema = z.object({
  name: z.string().min(1).max(40).optional(),
  scope: ScopeSchema.optional(),
  permissions: PermissionsMapSchema.optional(),
});
export type UpdateRoleRequest = z.infer<typeof UpdateRoleSchema>;
